import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import BaseCard from "../baseCard";
import MaterialTable from "material-table";
import {useQuery} from "@apollo/react-hooks";
import {GET_TASKS} from "../../../database/queries/taskQueries";
import tableIcons from "../../../constants/tableIcons";
import Moment from "react-moment";
import CalendarStrings from "../../../constants/calendarStrings";
import {AutoSizer} from 'react-virtualized';
import {notify} from "../../../utils/notify";
import {Link} from "react-router-dom";

const useStyles = makeStyles({
    root: {},
});

const TasksCard = props => {
    const classes = useStyles();

    const {loading: getTasksLoading, error: getTasksError, data: getTasksData, refetch: getTasksRefetch} = useQuery(GET_TASKS, {
        variables: {
            orderList: ['dueAt DESC']
        },
    });

    const columns = [
        {
            title: 'Task',
            width: '25%',
            render: r => {
                return (
                    <Link to={`/tasks/${r.shareCategoryType}/${r.shareCategoryId}/checkList/${r.taskId}`}>
                        {r.taskName}
                    </Link>
                );
            },
            headerStyle: {padding: 6},
            cellStyle: {padding: 6}
        },
        {
            title: 'Type',
            width: '15%',
            field: 'taskType',
            headerStyle: {padding: 6},
            cellStyle: {padding: 6}
        },
        {
            title: 'Status',
            width: '15%',
            field: 'taskStatus',
            headerStyle: {padding: 6},
            cellStyle: {padding: 6}
        },
        {
            title: 'Priority',
            width: '15%',
            field: 'taskPriority',
            headerStyle: {padding: 6},
            cellStyle: {padding: 6}
        },
        {
            title: 'Start',
            width: '15%',
            render: r => <Moment calendar={CalendarStrings}>{r.startAt}</Moment>,
            headerStyle: {padding: 6},
            cellStyle: {padding: 6}
        },
        {
            title: 'Due',
            width: '15%',
            render: r => <Moment calendar={CalendarStrings}>{r.dueAt}</Moment>,
            headerStyle: {padding: 6},
            cellStyle: {padding: 6}
        },
    ];

    useEffect(() => {
        if (getTasksError) notify('getTasksError', 'error', getTasksError.message);
    }, [getTasksError]);

    useEffect(() => {
        getTasksRefetch();
    }, [getTasksRefetch]);

    if (getTasksLoading) return <p>Loading ...</p>;
    if (getTasksError) return `Error! ${getTasksError.message}`;

    return (
        <AutoSizer>
            {({height, width}) => {
                const tableOptions = {
                    maxBodyHeight: height - 60,
                    padding: 'dense',
                    header: true,
                    paging: false,
                    showTitle: false,
                    search: false,
                    toolbar: false,
                    actionsColumnIndex: -1
                };
                return (
                    <BaseCard title={"Tasks"} height={height} width={width}>
                        <div className={classes.root}>
                            {getTasksData && getTasksData.tasks && (
                                <MaterialTable
                                    icons={tableIcons}
                                    columns={columns}
                                    data={getTasksData.tasks}
                                    options={tableOptions}
                                />
                            )}
                        </div>
                    </BaseCard>
                );
            }}
        </AutoSizer>
    );
};

export default TasksCard
